export default __webpack_public_path__ + "static/media/gb-nir.f9fcc604.svg";